"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var SendMoneyIcon = function SendMoneyIcon(props) {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    height: "30px",
    width: "30px",
    "aria-labelledby": "send-money-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "send-money-title"
  }, "Send Money"), _react["default"].createElement("polyline", {
    className: "cls-1 hvr-icon-stroke",
    points: "4 16 3 15 25 7 17 29 12 24 19.74 12.25 8 20 8 24 9 24",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2px"
  }), _react["default"].createElement("circle", {
    className: "cls-2 hvr-icon-fill",
    cx: "5.75",
    cy: "18.25",
    r: "1.25",
    fill: "#fff"
  }));
};

var _default = SendMoneyIcon;
exports["default"] = _default;